import PipelineShot from '../images/motionode/ticket-changes.png';
import CodeReviewShot from '../images/motionode/ai-builder-pr.png';

const processSteps = [
  'Ticket',
  'AI-assisted build',
  'Human review',
  'Staging',
  'QA',
  'Pull request',
  'Deployment',
];

const PoweredByMotionode = () => {
  return (
    <section className='motionodeWrapper' id='motionode'>
      <div className='containerFull'>
        <h3>Powered by <span className='text-pink-orange'>Motionode</span></h3>

        <div className='motionode-intro'>
          <p className='motionode-copy'>
            Motionode is our internal AI-assisted delivery platform. Every request is organized through
            tickets, connected to code changes, reviewed by humans, tested in staging, and prepared for
            controlled deployment.
          </p>
          <p className='motionode-supporting'>
            This allows us to move faster than a traditional development process while keeping the
            engineering controls real software systems need.
          </p>
        </div>

        <div className='motionode-screens'>
          <div className='motionode-screen'>
            <img src={PipelineShot} alt='Motionode ticket pipeline' loading='lazy' />
          </div>
          <div className='motionode-screen'>
            <img src={CodeReviewShot} alt='Motionode code changes and pull requests' loading='lazy' />
          </div>
        </div>

        <div className='motionode-flow'>
          {processSteps.map((step, index) => (
            <div className='motionode-flow-step' key={step}>
              <span className='motionode-flow-label'>{step}</span>
              {index < processSteps.length - 1 && (
                <span className='motionode-flow-arrow' aria-hidden='true'>&rarr;</span>
              )}
            </div>
          ))}
        </div>
      </div>

      <div className='bgCircle bgCircle-violet bgBlur-right-top'></div>
      <div className='bgCircle bgCircle-blue bgBlur-left-top'></div>
    </section>
  );
};

export default PoweredByMotionode;
